import "./style.css";
import bg1 from "Assets/Images/TopBusinesses/bg.png";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import { useLocation } from "react-router-dom";

const EachSubCategory = ({
  address,
  discount,
  sub_category_name,
  shop_name,
  tel,
  category_id,
  stars_avg,
  select_icon,
}) => {
  const { pathname } = useLocation();

  return (
    <Link to={pathname} className=" each-box-sub-category p-3 mb-4 ">
      <div className=" all-b-sub position-relative  w-100 ">
        <img
          src={`https://images.daapapp.com/covers/${category_id}.jpg`}
          alt=""
          className=""
        />
        <div className="persent-box-sub">
          <img src={bg1} alt="" />
          <p className=" position-absolute top-50  start-50 translate-middle  d-flex justify-content-center align-items-center">
            % <span>{discount}</span>
          </p>
        </div>
        <div className=" all-detail-box-shiri bg-shiri w-100 ps-3  overflow-auto d-flex justify-content-between align-items-center">
          <div className="name-businesses  d-flex   align-items-center ">
            <img src={`https://images.daapapp.com/${select_icon}`} alt="" />
            <div className=" d-flex flex-column justify-content-between align-items-center">
              <p className="shop-name-text mb-2">{shop_name}</p>

              <p className="mb-0 sub-name-text ">{sub_category_name}</p>
            </div>
          </div>
          <div className="adress-number-business d-flex flex-column pe-3">
            <h6 className="addres-text-sub text-black">{address}</h6>
            <p className="mb-0 phone-text-sub">{tel}</p>
          </div>
        </div>
        <div className=" star-sub-category   bg-white rounded-pill mb-0  px-2 m-0">
          {" "}
          <ReactStars
            edit={false}
            value={parseInt(stars_avg)}
            count={5}
            size={20}
            activeColor="#ffd700"
          />
        </div>
      </div>
    </Link>
  );
};

export default EachSubCategory;
